import mini from "./mini";
import att2 from "./att2";
import att4 from "./att4";
import att6 from "./att6";
import att8 from "./att8";

const platformCapabilities = {
    mini,
    att2,
    att4,
    att6,
    att8,
};

export default platformCapabilities;